import React from "react"

import { fetchCall } from "../../common/FetchHelpers";
import UserAccountsDetailComp from "./UserAccountDetailComp";

const UserAccountDeleteComp = (props) => {
    const deleteUrl = "api/user-account/UserAccount";


    const handleDelete = (id) => {
        const reqOptions = {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json"
            },
        };

        fetchCall(deleteUrl + "/" + id, reqOptions)
            .then((result)=>{
                props.handleDeleteComplete();

            })
            .catch((err)=>{
                console.log("Error, with message:", err.statusText);
            }
        );
    };

    return (
        <div className="panel">
            <div className="panel-header">
                <div className="panel-header-label">Closing Account</div>
            </div>
            <UserAccountsDetailComp data={props.data} />
            <div className="panel-footer">
                <div className="form-status error">Are you sure you want to close this account?</div>
                <div className="btn-group">
                    <button
                        type="button"
                        className="btn btn-primary-outline"
                        onClick={props.handleDeleteComplete}>Cancel</button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={p => handleDelete(props.data.id)}>Confirm Close Account</button>
                </div>
            </div>
        </div>
    )
};


export default UserAccountDeleteComp;
